<template>
  <div>
    <div class="container">
      <ul class="list-group vertical-steps">
        <li
          class="list-group-item"
          :class="{ active: getstartedStage == 1, completed: lastedStage >= 1 }"
        >
          <a href="javascript:void(0);" @click="goGetStartedStage(1)">
            <h5>{{ $t('Welcome Message') }}</h5>
          </a>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div v-if="getstartedStage == 1">
              <p>{{ $t('First greeting message to your customers (Not exceed 20 alphabets)') }}</p>
              <template v-if="isWelcomeLoading">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="45px"
                  width="7px"
                ></scale-loader>
              </template>
              <template v-else>
                <template v-if="welcome_intent">
                  <manage-intent
                    :type="'edit'"
                    :isCommentToInbox="false"
                    v-model="welcome_intent"
                    @saveIntent="saveWelcomeMessage"
                    :excludedIntentName="''"
                    :isWelcome="true"
                  >
                    <div slot="welcome" v-if="messages">
                      <intent-group
                        v-model="messages"
                        :isWelcome="true"
                        :intentname="welcome_intent.intentname"
                      ></intent-group>
                    </div>

                    <div slot="footer" slot-scope="scope">
                      <div style="margin-bottom: 15px">
                        <a
                          href="javascript:void(0);"
                          class="btn-preview"
                          @click="showPreview = true"
                        >
                          <em class="far fa-eye" />
                          {{ $t('preview') }}
                        </a>
                      </div>
                      <div style="margin-top: 25px">
                        <v-btn
                          href="javascript:void(0);"
                          color="primary"
                          depressed
                          @click="scope.saveIntent()"
                          >{{ $t('Next') }}</v-btn
                        >
                      </div>
                    </div>
                  </manage-intent>
                </template>
              </template>
            </div>
          </transition>
        </li>
        <li
          class="list-group-item"
          :class="{ active: getstartedStage == 3, completed: lastedStage >= 3 }"
        >
          <a href="javascript:void(0);" @click="goGetStartedStage(3)">
            <h5>{{ $t('Choice') }}</h5>
          </a>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div v-if="getstartedStage == 3">
              <p>{{ $t('Options for customers to quickly reply (Not exceed 20 alphabets)') }}</p>
              <quick-reply
                v-model="welcome_quickreplies"
                @onChangeChoice="onChangeChoice"
                :isEdit="true"
                @onSave="goNextGetStartedStage(5)"
              >
                <div slot="footer" slot-scope="scope">
                  <div style="margin-bottom: 15px">
                    <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                      <em class="far fa-eye" />
                      {{ $t('preview') }}
                    </a>
                  </div>
                  <div style="margin-top: 25px">
                    <v-btn
                      href="javascript:void(0);"
                      color="primary"
                      depressed
                      @click="scope.saveContent()"
                      >{{ $t('Next') }}</v-btn
                    >
                  </div>
                </div>
              </quick-reply>
            </div>
          </transition>
        </li>
        <li
          class="list-group-item"
          :class="{ active: getstartedStage == 5, completed: lastedStage >= 5 }"
        >
          <a href="javascript:void(0);" @click="goGetStartedStage(5)">
            <h5>{{ $t('Redeem Code') }}</h5>
          </a>
          <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div v-if="getstartedStage == 5">
              <p>
                {{
                  $t(
                    'For filling the redeem code/ support code when purchasing premium package from official resellers'
                  )
                }}
              </p>
              <div class="form-control text-xs-center my-4">
                <redeem-code :block-input="true"></redeem-code>
              </div>
              <div class="text-xs-right">
                <a href="javascript:void(0);" class="btn-large" @click="$emit('onCompleted')">{{
                  $t('Finish')
                }}</a>
              </div>
            </div>
          </transition>
        </li>
      </ul>
    </div>
    <preview-message
      v-if="showPreview"
      @close="showPreview = false"
      :messages="messages"
      :choice="previewChoices"
      :questions="questions"
    ></preview-message>
  </div>
</template>

<script>
import axios from 'axios'
import api from '@/api'
import Tags from '@/components/elements/Tags'
import IntentGroup from '@/components/view/intent/IntentGroup'
import PersistentMenu from '@/components/view/setting/PersistentMenu'
import { mapGetters } from 'vuex'
import QuickReply from '@/components/view/chatbot/QuickReply'
import ManageIntent from '@/components/view/intent/intent-manage'
import Intent from '@/components/view/intent/Intent'
import PreviewMessage from '@/components/elements/PreviewMessage'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import SupportCode from '@/components/view/billing/SupportCode'
import moment from 'moment'
import RedeemCode from '@/components/elements/RedeemCode'
import Presets from '@/components/view/getstarted/Presets'

export default {
  data: function () {
    return {
      isWelcomeLoading: true,
      getstartedStage: 1,
      lastedStage: 1,
      showPreview: false,

      welcome: {
        intents: [
          [
            {
              text: 'message',
              type: 'text'
            }
          ]
        ],
        customerSay: '',
        choice: ''
      },
      persistent_menu: undefined,
      type: 'json',
      messages: [[]],

      previewChoices: [],

      welcome_quickreplies: undefined,
      welcome_intent: undefined,

      showSupport: false
    }
  },
  components: {
    IntentGroup,
    Tags,
    PersistentMenu,
    QuickReply,
    ManageIntent,
    Intent,
    PreviewMessage,
    ScaleLoader,
    SupportCode,
    Presets,
    RedeemCode
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      pagelist: 'unsubscribedPage',
      loadingSetting: 'getLoadingSetting',
      contents: 'getSetting',
      currentLang: 'currentLang'
    }),
    replies: function () {
      var vm = this
      if (
        vm.welcome_quickreplies &&
        vm.welcome_quickreplies.contentvalue &&
        vm.welcome_quickreplies.contentvalue != null &&
        vm.welcome_quickreplies.contentvalue != ''
      ) {
        var tags = vm.welcome_quickreplies.contentvalue.split(',')
        var result = []
        $.each(tags, function (index, val) {
          result.push({ text: val })
        })
        return result
      } else {
        return []
      }
    },
    questions: function () {
      if (this.welcome_intent && this.welcome_intent.q_val != '') {
        return this.welcome_intent.q_val.split(',')
      } else {
        return []
      }
    }
  },
  created: function () {
    var vm = this
    if (vm.$route.query.step && vm.$route.query.step >= 1 && vm.$route.query.step <= 5) {
      let step = parseInt(vm.$route.query.step)
      vm.getstartedStage = step
      vm.lastedStage = step
    } else {
      vm.getstartedStage = 1
      vm.lastedStage = 1
    }

    if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting').then(function () {
      if (vm.contents && vm.contents.welcome_quickreplies) {
        vm.welcome_quickreplies = vm.contents.welcome_quickreplies
      }
    })

    // vm.getSetting(function() {})
    if (vm.selectedBot.supportusers) {
      vm.showSupport = true
    }
    this.loadIntent()
  },
  methods: {
    loadIntent() {
      var vm = this
      vm.isWelcomeLoading = true
      vm.getIntent(function () {
        vm.getWelcomeMessage(function () {
          vm.cached_message = vm.message
          vm.cached_generics = []
          $.each(vm.generics, function (index, generic) {
            vm.cached_generics[index] = Object.assign({}, generic)
            vm.cached_generics[index].buttons = []
            $.each(generic.buttons, function (bindex, button) {
              vm.cached_generics[index].buttons[bindex] = Object.assign({}, button)
            })
          })
          vm.cached_type = vm.type
          vm.isWelcomeLoading = false
        })
      })
    },
    updateRoute: function () {
      var url = {
        name: 'Setup',
        path: '/' + this.currentLang + '/setup',
        query: {
          step: this.lastedStage
        }
      }
      if (this.$route.query.supportcode) {
        url.query.supportcode = this.$route.query.supportcode
      }

      this.$router.push(url)
    },
    onChangeChoice: function (payload) {
      this.previewChoices = payload
    },
    saveWelcomeMessage: function () {
      let vm = this
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json'
      }

      vm.$store.dispatch('loading')
      var messages = []
      $.each(vm.messages, function (index, message) {
        var group = []
        $.each(message, function (mindex, msg) {
          if (msg.type == 'text') {
            if (msg.text != '' && msg.text != null) {
              group.push(msg)
            }
          } else if (msg.type == 'button') {
            if ((msg.text != '' && msg.text != null) || msg.buttons.length > 0) {
              group.push(msg)
            }
          } else if (msg.type == 'image') {
            if (msg.image_url) {
              group.push(msg)
            }
          } else if (msg.type == 'generic') {
            var generics = []
            $.each(msg.data, function (gindex, generic) {
              if (
                generic.image_url != null ||
                generic.title != '' ||
                generic.subtitle != '' ||
                generic.buttons.length > 0
              ) {
                generics.push(generic)
              }
            })
            if (generics.length > 0) {
              group.push({
                type: 'generic',
                data: generics,
                ratio: msg.ratio == 'horizontal' ? 'horizontal' : 'square'
              })
            }
          } else {
            group.push(msg)
          }
        })
        if (group.length > 0) {
          messages.push(group)
        }
      })

      if (messages.length == 0) {
        messages = [[]]
      }

      data['message'] = JSON.stringify(messages)

      api.saveWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        // console.log(data)
        vm.cached_type = vm.type
        vm.$store.dispatch('updateWelcomeMessage', {
          type: 'json',
          message: null,
          generics: null,
          messages: messages
        })
        vm.$store.dispatch('loading')
        vm.goNextGetStartedStage(3)
      })
    },
    getSetting: function (callback) {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        vm.contents = {}
        $.each(response.data, function (index, val) {
          vm.contents[val.contenttype] = val
          if (val.contenttype == 'allowtransfer') {
            vm.isTransfer = val.contentvalue
          }
        })
        callback()
      })
    },
    goGetStartedStage: function (target) {
      if (target <= this.lastedStage) {
        this.getstartedStage = target
      }
    },
    goNextGetStartedStage: function (next) {
      var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
      if (next > this.lastedStage) {
        this.lastedStage = next
        this.$ga.event('event', prefix + 'first_time_step2_' + next, this.selectedBot.pagename)
      }
      if (next == 2) {
        this.loadIntent()
      }
      this.$ga.event('event', prefix + 'step2_' + next, this.selectedBot.pagename)
      this.getstartedStage = next
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }

      vm.message = null
      vm.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ]
      vm.type = 'json'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          callback(false)
          return
        }
        if (response.data) {
          if (response.data.type != 'json') {
            if (response.data.type == 'message') {
              var group = []
              if (response.data.message_text == '') {
                vm.messages = [[]]
              } else {
                var group_messages = response.data.message_text.split('||')
                $.each(group_messages, function (index, messages) {
                  var messages = messages.split('#nl')
                  var newMessages = []
                  $.each(messages, function (inedx, message) {
                    if (vm.isURL(message)) {
                      newMessages.push({
                        type: 'image',
                        image_url: message
                      })
                    } else if (!isNaN(message)) {
                      newMessages.push({
                        type: 'text',
                        text: message
                      })
                    } else if (vm.isJsonParseable(message)) {
                      var parsedMessage = JSON.parse(message)
                      // console.log(message);
                      newMessages.push({
                        type: 'button',
                        text: parsedMessage.text ? parsedMessage.text : '',
                        buttons: parsedMessage.buttons ? parsedMessage.buttons : []
                      })
                    } else {
                      newMessages.push({
                        type: 'text',
                        text: message
                      })
                    }
                  })
                  group.push(newMessages)
                })

                vm.messages = group
              }
            } else if (response.data.type == 'generic') {
              vm.messages[0][0] = {
                type: 'generic',
                data: response.data.message,
                ratio: response.ratio == 'horizontal' ? 'horizontal' : 'square'
              }
            }
          } else {
            vm.messages = JSON.parse(response.data.message)
          }
          vm.type = 'json'

          if (
            response.data.message &&
            typeof response.data.message === 'object' &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function (index, val) {
              vm.generics[index] = val
              vm.generics[index].enable = true
            })
          }
        }
        callback(true)
      })
    },
    getPersistentMenu: function (callback) {
      var vm = this
      var url =
        'https://graph.facebook.com/me/messenger_profile?fields=persistent_menu&access_token=' +
        vm.$store.state.selectedBot.page_access_token
      axios.get(url).then((response) => {
        if (response.status == 200) {
          var response = response.data
          if (
            response.data[0] &&
            response.data[0]['persistent_menu'] &&
            response.data[0]['persistent_menu'][0] &&
            response.data[0]['persistent_menu'][0]['call_to_actions']
          ) {
            vm.persistent_menu = response.data[0]['persistent_menu'][0]['call_to_actions']
            callback()
          }
        }
      })
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundWelcome = false
          $.each(response.data, function (index, val) {
            var intent = val
            intent.isShow = false
            if (intent.intentname == '{welcome}') {
              isFoundWelcome = true
              intent.ableToDelete = false
              vm.welcome_intent = intent
            }
          })

          if (!isFoundWelcome) {
            vm.welcome_intent = {
              intentname: '{welcome}',
              q_type: 'text',
              a_type: 'json',
              q_val: '',
              a_val: [[]],
              context_in: '',
              context_out: '',
              ableToDelete: false,
              isShow: false
            }
          }
        }
        callback()
      })
    }
  },
  watch: {
    lastedStage: function () {
      this.updateRoute()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/getstarted/SetupBot.vue